import url_ from "asset-data:assets/galleries/ua-2021-12-09/L1001046-color_62f85e18b5__800.jpg";
export const url = url_;